import { HttpClient } from "@angular/common/http";
import { UrlServidor } from "../util/url-servidor";
import { Injectable } from "@angular/core";
import { Observable, of, tap } from "rxjs";
import { DanfeCstPis } from "../api/dto/danfe/danfe-cst-pis";
import { CacheService } from "./cache/cache.service";

@Injectable({
    providedIn: 'root',
})
export class DanfeCstPisService {

    constructor(private http: HttpClient, private cacheService: CacheService<DanfeCstPis[]>) { }

    private url : string = UrlServidor.URL_BASE + 'danfe-cst-pis';
    private cacheKey = 'danfe-cst-pis';
    private expiration = 240 * 60 * 1000;

    listar(): Observable<DanfeCstPis[]>{
        const cachedData = this.cacheService.get(this.cacheKey);

        if (cachedData) {
            return of(cachedData);
        } else {
            return this.http.get<DanfeCstPis[]>(this.url)
            .pipe(
                tap(response => this.cacheService.set(this.cacheKey, response, this.expiration))
              );
        }
    }
}